var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgDelete = function SvgDelete(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 16,
    viewBox: "0 0 12 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.00002 13.8333C1.00002 14.75 1.75002 15.5 2.66669 15.5H9.33335C10.25 15.5 11 14.75 11 13.8333V5.5C11 4.58333 10.25 3.83333 9.33335 3.83333H2.66669C1.75002 3.83333 1.00002 4.58333 1.00002 5.5V13.8333ZM3.50002 5.5H8.50002C8.95835 5.5 9.33335 5.875 9.33335 6.33333V13C9.33335 13.4583 8.95835 13.8333 8.50002 13.8333H3.50002C3.04169 13.8333 2.66669 13.4583 2.66669 13V6.33333C2.66669 5.875 3.04169 5.5 3.50002 5.5ZM8.91669 1.33333L8.32502 0.741667C8.17502 0.591667 7.95835 0.5 7.74169 0.5H4.25835C4.04169 0.5 3.82502 0.591667 3.67502 0.741667L3.08335 1.33333H1.00002C0.541687 1.33333 0.166687 1.70833 0.166687 2.16667C0.166687 2.625 0.541687 3 1.00002 3H11C11.4584 3 11.8334 2.625 11.8334 2.16667C11.8334 1.70833 11.4584 1.33333 11 1.33333H8.91669Z",
    fill: "#777776"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDelete, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/delete.c63e209c.svg";
export { ForwardRef as ReactComponent };